import { ShowItemService } from 'application/services/show-item'
import { api } from 'infra/adapters/http-client-adapter'

export const handleShowItem = new ShowItemService(api)
